import { render } from "./admissionResults.vue?vue&type=template&id=762ef384&ts=true"
import script from "./admissionResults.vue?vue&type=script&lang=ts"
export * from "./admissionResults.vue?vue&type=script&lang=ts"

import "./admissionResults.vue?vue&type=style&index=0&id=762ef384&lang=css"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__